/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { resetStart, resetStep, resetPerson, resetAddress, resetThirdParty, resetMailShip, resetExportImport, 
  resetCurrencyItem, resetCoinItem, resetOtherItem, resetReviewSign, resetReceipt,
  nextStep, previousStep, updateStart, updatePerson, updateAddress, updateThirdParty, updateExportImport, 
  updateCarrier, updateMailShip, updateShip,
  updateCurrencies, updateCoins, updateOthers, updateReviewSign, updateReceipt} from '../actions';
import { styled } from '@mui/material/styles';
import { Paper, Typography, Button, FormControlLabel, Checkbox, Tooltip, Divider, IconButton, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import NumberFormat from 'react-number-format';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import InfoIcon from '@mui/icons-material/Info';
// import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SignatureCanvas from 'react-signature-canvas'
import Popup from 'reactjs-popup';
import NavigationButtons from '../container/NavigationButtons';
import MDTextField from './custom/MDTextField';
import AsyncReactSelect from './custom/AsyncReactSelect';
import Person from './custom/Person';
import Address from './custom/Address';
import CurrencyItem from './CurrencyItem';
import dateFormat from 'dateformat';
import ReactTooltip from "react-tooltip";
 
// Shared style configurations for ReviewSign buttons
const editButtonSx = {
  fontSize: '0.75rem',
  fontWeight: '600',
  p: '4px',
  m: '4px',
  textTransform: 'capitalize',
  backgroundColor: '#3939c8',
  '&:hover': {
    backgroundColor: '#1976d2',
  },
};

const saveButtonSx = {
  fontSize: '0.75rem',
  fontWeight: '600',
  p: '4px',
  m: '4px',
  textTransform: 'capitalize',
};

const popupCloseButtonSx = {
  ml: 1,
  mr: 1,
  width: 130,
};

function ReviewSign(props) {
  const dispatch = useDispatch()
  let sigCanvas = useRef(null);

  const activeStep = useSelector((state) => state.activeStep)
  const start = useSelector((state) => state.start)
  const person = useSelector((state) => state.person)
  const addresses = useSelector((state) => state.addresses)
  const exportImport = useSelector((state) => state.exportImport)
  const carrier = useSelector((state) => state.carrier)
  const mailship = useSelector((state) => state.mailship)
  const ship = useSelector((state) => state.ship)
  const thirdParty = useSelector((state) => state.thirdparty)
  const currencies = useSelector((state) => state.currencies)
  const coins = useSelector((state) => state.coins)
  const others = useSelector((state) => state.others)

  const [required, setRequired] = useState(props.required);
  const [sameAddress, setSameAddress] = useState(false);
  const [open, setOpen] = useState(false);
  const [reviewPage, setReviewPage] = useState(false);
  const [alertType, setAlertType] = useState('R');
  const [incurrencysummary, setIncurrencysummary] = useState(true);
  const [showClear, setShowClear] = useState(false);
  const [declaration, setDeclaration] = useState(false);
  const [acknowledgement, setAcknowledgement] = useState(false);
  const [personalsummary, setPersonalsummary] = useState(true);
  const [addresssummary, setAddresssummary] = useState(true);
  const [exportimportsummary, setExportimportsummary] = useState(true);
  const [mailshipSummary, setMailshipSummary] = useState(true);
  const [currencysummary, setCurrencysummary] = useState(true);
  const [thirdPartySummary, setThirdPartySummary] = useState(true);
  const [locator, setLocator] = useState('');

  const [review, setReview] = useState({...props.review, signDate: dateFormat(new Date(), "UTC:yyyy-mm-dd")});
  const [requiredFields, setRequiredFields] = useState({signName: false, person: true, thirdParty: true, 
              exportImport: true, departureCountry: true, departurePort: true, arriveCountry: true, arrivePort: true,
              mailship: true, shipDate: true, receiveDate: true,
              address0: true, address1: true, address2: true, address3: true, address4: true});

  // constructor(props) {
  //   super(props);
  //   state = { activeStep: props.activeStep, person: props.person, addresses: props.addresses,  exportImport: props.exportImport, 
  //             carrier: props.carrier, mailship: props.mailship, ship: props.ship, required: props.required,
  //             thirdParty: props.thirdParty, currencies: props.currencies, coins: props.coins, others: props.others, sameAddress: false, open: false, reviewPage:false,
  //             review: {...props.review, signDate: dateFormat(new Date(), "UTC:yyyy-mm-dd")}, alertType: 'R', incurrencysummary: true,
  //             showClear: false, declaration: false, acknowledgement: false, 
  //             personalsummary: true, addresssummary: true, exportimportsummary: true, mailshipSummary: true, currencysummary: true, thirdPartySummary: true, locator:'',
  //             requiredFields: { signName: false, person: true, thirdParty: true, 
  //               exportImport: true, departureCountry: true, departurePort: true, arriveCountry: true, arrivePort: true,
  //               mailship: true, shipDate: true, receiveDate: true,
  //               address0: true, address1: true, address2: true, address3: true }};
  // }

  // static getDerivedStateFromProps(nextProps, prevState) {   
  //   if (nextProps.activeStep !== prevState.activeStep) {
  //     if(nextProps.person !== prevState.person) {          
  //       return { activeStep: nextProps.activeStep, person: nextProps.person }
  //     } else if(nextProps.thirdParty !== prevState.thirdParty) {        
  //       return { activeStep: nextProps.activeStep, thirdParty: nextProps.thirdParty }
  //     } else if(nextProps.addresses !== prevState.addresses) {      
  //       return { activeStep: nextProps.activeStep, addresses: nextProps.addresses }
  //     } else if(nextProps.exportImport !== prevState.exportImport) {      
  //       return { activeStep: nextProps.activeStep, exportImport: nextProps.exportImport }
  //     } else if(nextProps.mailship !== prevState.mailship) {      
  //       return { activeStep: nextProps.activeStep, mailship: nextProps.mailship, carrier: nextProps.carrier, ship: nextProps.ship }
  //     } else if(nextProps.required !== prevState.required) {      
  //       return { activeStep: nextProps.activeStep, required: nextProps.required }
  //     } else if(nextProps.currencies !== prevState.currencies || nextProps.coins !== prevState.coins || nextProps.others !== prevState.others) {          
  //       return { activeStep: nextProps.activeStep, currencies: nextProps.currencies, coins: nextProps.coins, others: nextProps.others }
  //     } else return { activeStep: nextProps.activeStep }
  //   } else 
  //     return null
  // }

  const handleChange = (propertyName, value) => {
    const newReview = {
      ...review,
      [propertyName]: value
    };
    setReview(newReview)
    // 3. Immediately dispatch this change to the central Redux store.
        dispatch(updateReviewSign(newReview));
  }

  const handleDeclarationChecked = (propertyName) => (event) => {
    setDeclaration(declaration? false : true)
    handleChange('declaration', declaration? false : true)
  }

  const handleAcknowledgementChecked = (propertyName) => (event) => {
    setAcknowledgement(acknowledgement? false : true );
    handleChange('acknowledgement', acknowledgement? false : true)
  }

  const clearSign = () => {
    // sigCanvas.clear()
    if (sigCanvas.current != null) {
      sigCanvas.current.clear();
    }
    setShowClear(false)
  }

  const enableClearButton = () => {
    setShowClear(true)
  }

  const captureSignature = () => {
    const newReview = {
      ...review,
      // sigImageBase64: sigCanvas.getCanvas().toDataURL('image/png')
      sigImageBase64: sigCanvas.current.toDataURL('image/png')
    };
    setReview(newReview)
      
        // This sends the guaranteed-to-be-latest data (including the signature)
        // to the Redux store, solving the timing issue.
        dispatch(updateReviewSign(newReview));
  }

  const closepopup = (event) => {
   setOpen(false)
  }

  const toggleSummary = (selection) => { 
    if (selection === 'PI') {
      setPersonalsummary(personalsummary? false : true)
      if (!personalsummary) {  
        if (!requiredFields.person || !requiredFields.address0 || !requiredFields.address1) {
          setPersonalsummary(false)
          setOpen(true)
          setAlertType('R')
        } else {
          // props.updatePerson(person);
          // props.updateAddress(addresses);
          dispatch( updatePerson(person) )
          dispatch( updateAddress(addresses) )
        }        
      }
    } else if (selection === 'TP') {
      setThirdPartySummary(thirdPartySummary? false : true)
      if (!thirdPartySummary) {
        if (!requiredFields.person || !requiredFields.address2) {
          setThirdPartySummary(false)
          setOpen(true)
          setAlertType('R')
        } else {
          // props.updateThirdParty(thirdParty);
          // props.updateAddress(addresses);
          dispatch( updateThirdParty(thirdParty) )
          dispatch( updateAddress(addresses) )
        }        
      }
    } else if (selection === 'EI') {
      setExportimportsummary(exportimportsummary? false : true)
      if (!exportimportsummary) {
        if (!requiredFields.exportImport) {
          setExportimportsummary(false)
          setOpen(true)
          setAlertType('R')
        } else {
          // props.updateExportImport(exportImport);
          dispatch( updateExportImport(exportImport) )
        }
      }
    } else if (selection === 'MS') {
      setMailshipSummary(mailshipSummary? false : true)
      if (!mailshipSummary) {
        if (!requiredFields.mailship || !requiredFields.address3) {
          setMailshipSummary(false)
          setOpen(true)
          setAlertType('R')
        } else {
          // props.updateMailShip(mailship);
          // props.updateAddress(addresses);
          dispatch( updateMailShip(mailship) )
          dispatch( updateAddress(addresses) )
        }
      }    
    } else if (selection === 'MI') {
      setCurrencysummary(currencysummary? false : true)
      let currtotal = 0;  

      if (!currencysummary) {
        currencies.map(curr => (currtotal += Math.round(curr.usdEquivalent)));
        if (Math.round(currtotal) < 10000 || Math.round(currtotal) > 2147483647 ) {  
          setCurrencysummary(false)
          setOpen(true)
          setAlertType('M')
        } else if (!incurrencysummary) {
          setCurrencysummary(false)
        } else {
          // props.updateCurrencies(currencies);
          // dispatch( updateCurrencies(currencies) )
        }
      }
    }    
  }

  const handleChangeChecked = (propertyName) => (event) => {
    const addressP = addresses[0]
    let newAddress

    newAddress = {
      ...addressP,
      type: '1'
    };
    
    addresses[1] = newAddress    
    // setState({ addresses: addresses, sameAddress: sameAddress? false : true });
    setSameAddress(sameAddress? false : true )
    dispatch( updateAddress(newAddresses) )
  }

  const updatePersonSummary = (person) => {
    // setState({ person: person });
    dispatch( updatePerson(person) )
  }

  const updateThirdPartySummary = (person) => {
    const newThirParty = {
      ...thirdParty,
      ...person
    }
    // setState({ thirdParty: newThirParty });
    dispatch( updateThirdParty(newThirParty) )
  }

  const updateMailShipSummary = (propertyName, value) => {  
    const newMailShip = {
      ...mailship,
      [propertyName]: value,
      
    };
    // setState({ mailship: newMailShip});
    dispatch( updateMailShip(newMailShip) )
  }

  const updateMailShipPersonSummary = (person) => {
    const newMailShip = {
      ...mailship,
      first: person.first,
      last: person.last,
      middle: person.middle,
      business: person.business
    }
    // setState({ mailship: newMailShip });
    dispatch( updateMailShip(newMailShip) )
  }

  const updateAddressSummary = (address, index) =>  {
    const newAddresses = addresses

    newAddresses[index] = address      
    
    if (index === '0' && sameAddress) {
      newAddresses[1] = address
    }

    // setState({addresses: newAddresses, sameAddress: (index === '1'? false : sameAddress)});   
    setSameAddress(index === '1'? false : sameAddress)  
    dispatch( updateAddress(newAddresses) )
  }

  const updateExportImportSummary = (propertyName, value) => {  
    const newExportImport = {
      ...exportImport,
      [propertyName]: value,
      
    };
    // setState({ exportImport: newExportImport});
    dispatch( updateExportImport(newExportImport) )
  }

  const updateCurrency = (currency, incurrencysummary, type, oper) =>  {
      const selectedIndex = currencies.map(function(e) { return e.id; }).indexOf(currency.id);
      
      let updatedCurrencies = currencies;
      const newCurrency = currencies[selectedIndex];
      const updatedCurrency = {...newCurrency, 
        amount: currency.amount,
        usdEquivalent: currency.amount >= 1 ? Math.round(currency.amount * currency.exchangeRate) : 0
      };
      let ctotal = 0;

      updatedCurrencies[selectedIndex] = updatedCurrency;
      updatedCurrencies.map(curr => (ctotal += curr.usdEquivalent));

      // currencies[selectedIndex] = updatedCurrency;
      // currencies.map(curr => (ctotal += curr.usdEquivalent));

      // setState({
      //   incurrencysummary: incurrencysummary,
      //   currencies: updatedCurrencies,
      //   currTotal: ctotal
      // });
      
      setIncurrencysummary(incurrencysummary)
      // dispatch( updateCurrencies(updatedCurrencies) )
  }

  const handleError = (propertyName, error) => {
    let newRequiredFields = {
      ...requiredFields,
      [propertyName]: (propertyName === 'shipDate' || propertyName === 'receiveDate' || propertyName === 'signName' || propertyName === 'departureCountry' ||
         propertyName === 'departurePort' || propertyName === 'arriveCountry' || propertyName === 'arrivePort')? !error : error,      
    };

    if (!exportimportsummary) {
      if (newRequiredFields.person && newRequiredFields.departureCountry && newRequiredFields.departurePort 
            && newRequiredFields.arriveCountry && newRequiredFields.arrivePort) {
        newRequiredFields = { ...newRequiredFields, exportImport: true };
      } else {
        newRequiredFields = { ...newRequiredFields, exportImport: false };
      }
    }

    if (!mailshipSummary) {
      if (newRequiredFields.person && newRequiredFields.shipDate && newRequiredFields.receiveDate) {
          newRequiredFields = { ...newRequiredFields, mailship: true };
      } else {
          newRequiredFields = { ...newRequiredFields, mailship: false };   
      }
    }
    
    setRequiredFields(newRequiredFields)
  }

  const computeTotal = (currencies) => {
    let total = 0;
    currencies.map(currency => {
      return total += Number(Math.round(currency.usdEquivalent))
    })
    return total;
  };

  return (
    <div>
          <Paper sx={{ m: 1, p: 1, textAlign: 'left', color: 'text.primary', backgroundColor: '#ffffff' }}>
            <Grid container sx={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>{start.personalOrBusiness === 'B'? 'Business Information' : 'Personal Information'}</Typography>         
              {personalsummary && <Button size="small" variant="contained" color="primary" sx={editButtonSx} onClick={() => toggleSummary('PI')}>
                edit
                <EditIcon sx={{ ml: 1 }} />                  
              </Button>}
              {!personalsummary && <Button size="small" variant="contained" color="error" sx={saveButtonSx} onClick={() => toggleSummary('PI')}>
                Save
                <SaveIcon sx={{ ml: 1 }} />                  
              </Button>}                
            </Grid>
            <Person person={person} reviewPage={true} locator='Review'  updatePerson={updatePersonSummary} summary={personalsummary} 
                    business={start.personalOrBusiness === 'B'? true : false} handleError={handleError} />

            <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>{start.personalOrBusiness === 'B'? 'Business ' : undefined}
              Permanent Address in United States or Abroad
            </Typography>
            <Address address={addresses[0]} index='0' reviewPage={true} locator='Review' updateAddress={updateAddressSummary} summary={personalsummary} handleError={handleError} 
            inUnitedStates={(addresses[0].country === undefined || addresses[0].country === null || 
                            (addresses[0].country !== null  && addresses[0].country.value === "USA"))} />
            
            {start.personalOrBusiness === 'P' &&
            <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Address while in the United States</Typography>
            }
            {start.personalOrBusiness === 'P' &&
            <Address address={addresses[1]} index='1' reviewPage={true} locator='Review' updateAddress={updateAddressSummary} summary={personalsummary} handleError={handleError} 
            inUnitedStates={true} />
            }
          </Paper>
          
          { (start.pct === 'Y' || start.mailingOrPhysical === 'P') &&
          <Paper sx={{ m: 1, p: 1, textAlign: 'left', color: 'text.primary', backgroundColor: '#ffffff' }}>
            <Grid container sx={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>
                        {exportImport.exportOrImport === 0? 'Import' : 'Export'} Information</Typography>
              {exportimportsummary && <Button size="small" variant="contained" color="primary" sx={editButtonSx} onClick={() => toggleSummary('EI')}>
                Edit
                <EditIcon sx={{ ml: 1 }} />                  
              </Button>}
              {!exportimportsummary && <Button size="small" variant="contained" color="error" sx={saveButtonSx} onClick={() => toggleSummary('EI')}>
                Save
                <SaveIcon sx={{ ml: 1 }} />                  
              </Button>} 
            </Grid>              
            
            <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>
              <AsyncReactSelect name='departureCountry' label='Country of Departure' locator='Review' value={exportImport.departureCountry} placeholder='Search for Country' errorText='Please select country' 
                  optionsType='country' handleChange={updateExportImportSummary} required={true} disabled={exportImport.exportOrImport === 1 || exportimportsummary? true : false} 
                  summary={exportimportsummary} handleError={handleError} />
              <MDTextField name='departurePort' label='Departed City/Port' locator='Review' value={exportImport.departurePort}  handleChange={updateExportImportSummary} required={true} 
                  disabled={exportimportsummary? true : false} summary={exportimportsummary} handleError={handleError} />
              <AsyncReactSelect name='arriveCountry' label='Country of Arrival' locator='Review' value={exportImport.arriveCountry} placeholder='Search for Country' errorText='Please select country' 
                  optionsType='country' handleChange={updateExportImportSummary} required={true} disabled={exportImport.exportOrImport === 0 || exportimportsummary? true : false}
                  summary={exportimportsummary} handleError={handleError} />
              <MDTextField name='arrivePort' label='Arrival City/Port' locator='Review' value={exportImport.arrivePort}  handleChange={updateExportImportSummary} required={true} 
                  disabled={exportimportsummary? true : false} summary={exportimportsummary} handleError={handleError} />                
            </Grid>
          </Paper>
          }

{/* Mailed or Shipped - Regular Workflow */}
        {(start.pct === 'N' && start.mailingOrPhysical === 'M') && 
            <Paper sx={{ m: 1, p: 1, textAlign: 'left', color: 'text.primary', backgroundColor: '#ffffff' }}>
            <Grid container sx={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>
                        {mailship.sendOrReceive === 0? 'Shipping' : 'Receiving'} Information</Typography>
              {mailshipSummary && <Button size="small" variant="contained" color="primary" sx={editButtonSx} onClick={() => toggleSummary('MS')}>
                Edit
                <EditIcon sx={{ ml: 1 }} />                  
              </Button>}
              {!mailshipSummary && <Button size="small" variant="contained" color="error" sx={saveButtonSx} onClick={() => toggleSummary('MS')}>
                Save
                <SaveIcon sx={{ ml: 1 }} />                  
              </Button>} 
            </Grid> 

            <Person person={mailship} reviewPage={true} locator='Review' updatePerson={updateMailShipPersonSummary} summary={mailshipSummary} shiprecv={true} 
              business={mailship.business !== ''? true : false} handleError={handleError} />
            
            <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>
            {(mailship.sendOrReceive === -1 || mailship.sendOrReceive === 0) &&
              <MDTextField name='shipDate' label='Date Shipped' locator='Review' value={mailship.shipDate} type='date' handleChange={updateMailShipSummary} required={true} 
                  disabled={mailshipSummary? true : false} summary={mailshipSummary} handleError={handleError} />                
            }
            {mailship.sendOrReceive === 1 &&
              <MDTextField name='receiveDate' label='Date Received' locator='Review' value={mailship.receiveDate} type='date' handleChange={updateMailShipSummary} required={true} 
                  disabled={mailshipSummary? true : false} summary={mailshipSummary} handleError={handleError} />                
            }
              <MDTextField name='methodOfShipment' label='Method of Shipment' locator='Review' value={mailship.methodOfShipment}  handleChange={updateMailShipSummary} required={false} 
                  disabled={mailshipSummary? true : false} summary={mailshipSummary} handleError={handleError} />                
              <MDTextField name='carrierName' label='Carrier Name' locator='Review' value={mailship.carrierName}  handleChange={updateMailShipSummary} required={false} 
                  disabled={mailshipSummary? true : false} summary={mailshipSummary} handleError={handleError} />                    
            </Grid>

            <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>{mailship.sendOrReceive === 0? 'Ship To' : 'Received From'}</Typography>
            <Address address={addresses[3]} index='3' reviewPage={true} locator='Review' updateAddress={updateAddressSummary} summary={mailshipSummary} handleError={handleError}
            inUnitedStates={(addresses[3].country === undefined || addresses[3].country === null || 
                            (addresses[3].country !== null  && addresses[3].country.value === "USA"))} />    
          </Paper>

          }

{/* Mailed or Shipped - Currency Transporter Workflow */}
        {(start.pct === 'Y' && start.mailingOrPhysical === 'M') && 
          <Paper sx={{ m: 1, p: 1, textAlign: 'left', color: 'text.primary', backgroundColor: '#ffffff' }}>
            <Grid container sx={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Shipping/Receiving Information</Typography>

              {mailshipSummary && <Button size="small" variant="contained" color="primary" sx={editButtonSx} onClick={() => toggleSummary('MS')}>
                Edit
                <EditIcon sx={{ ml: 1 }} />                  
              </Button>}
              {!mailshipSummary && <Button size="small" variant="contained" color="error" sx={saveButtonSx} onClick={() => toggleSummary('MS')}>
                Save
                <SaveIcon sx={{ ml: 1 }} />                  
              </Button>} 
            </Grid> 
            
            <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>             
              <MDTextField name='shipDate' label='Date Shipped' locator='Review' value={mailship.shipDate} type='date' handleChange={updateMailShipSummary} required={true} 
                  disabled={mailshipSummary? true : false} summary={mailshipSummary} handleError={handleError} />             
              <MDTextField name='methodOfShipment' label='Method of Shipment' locator='Review' value={mailship.methodOfShipment}  handleChange={updateMailShipSummary} required={false} 
                  disabled={mailshipSummary? true : false} summary={mailshipSummary} handleError={handleError} />                
            </Grid>

            <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Carrier Information</Typography>
            <Person person={carrier} reviewPage={true} locator='Review' updatePerson={updateMailShipPersonSummary} summary={mailshipSummary} shiprecv={true} 
              business={carrier.business !== ''? true : false} handleError={handleError} />
            
            <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Receiver Information</Typography>
            <Person person={mailship} reviewPage={true} locator='Review' updatePerson={updateMailShipPersonSummary} summary={mailshipSummary} shiprecv={true} 
              business={mailship.business !== ''? true : false} handleError={handleError} />
            {/* <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Receiver Address</Typography> */}
            <Address address={addresses[4]} index='4' reviewPage={true} locator='Review' updateAddress={updateAddressSummary} summary={mailshipSummary} handleError={handleError}
            inUnitedStates={(addresses[4].country === undefined || addresses[4].country === null || 
                            (addresses[4].country !== null  && addresses[4].country.value === "USA"))} />

            <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Shipper Information</Typography>
            <Person person={ship} reviewPage={true} locator='Review' updatePerson={updateMailShipPersonSummary} summary={mailshipSummary} shiprecv={true} 
              business={ship.business !== ''? true : false} handleError={handleError} />
            {/* <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Shipper Address</Typography> */}
            <Address address={addresses[3]} index='3' reviewPage={true} locator='Review' updateAddress={updateAddressSummary} summary={mailshipSummary} handleError={handleError}
            inUnitedStates={(addresses[3].country === undefined || addresses[3].country === null || 
                            (addresses[3].country !== null  && addresses[3].country.value === "USA"))} />    
          </Paper>
          }

          {(start.myselfOrSomeone === 'S') && 
          <Paper sx={{ m: 1, p: 1, textAlign: 'left', color: 'text.primary', backgroundColor: '#ffffff' }}>
            <Grid container sx={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Third Party Information</Typography>         
              {thirdPartySummary && <Button size="small" variant="contained" color="primary" sx={editButtonSx} onClick={() => toggleSummary('TP')}>
                Edit
                <EditIcon sx={{ ml: 1 }} />                  
              </Button>}
              {!thirdPartySummary && <Button size="small" variant="contained" color="error" sx={saveButtonSx} onClick={() => toggleSummary('TP')}>
                Save
                <SaveIcon sx={{ ml: 1 }} />                  
              </Button>}                
            </Grid>              
            <Person person={thirdParty} reviewPage={true} updatePerson={updateThirdPartySummary} summary={thirdPartySummary} thirdParty={true} 
                    business={thirdParty.business !== ''? true : false} locator='Review' handleError={handleError} />
            
            <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Third Party Address</Typography>              
            <Address address={addresses[2]} index='2' reviewPage={true} locator='Review' updateAddress={updateAddressSummary} summary={thirdPartySummary} handleError={handleError}
            inUnitedStates={(addresses[2].country === undefined || addresses[2].country === null || 
                            (addresses[2].country !== null  && addresses[2].country.value === "USA"))} />
          </Paper>
          }

          <Paper sx={{ m: 1, p: 1, textAlign: 'left', color: 'text.primary', backgroundColor: '#ffffff' }}>
          <Grid container sx={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>              
            <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Monetary instruments Information</Typography>
              {currencysummary && <Button size="small" variant="contained" color="primary" sx={editButtonSx} onClick={() => toggleSummary('MI')}>
                Edit
                <EditIcon sx={{ ml: 1 }} />                  
              </Button>}
              {!currencysummary && <Button size="small" variant="contained" color="error" sx={saveButtonSx} onClick={() => toggleSummary('MI')}>
                Save
                <SaveIcon sx={{ ml: 1 }} />                  
              </Button>}  
            </Grid>

            <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-around', alignItems: 'flex-end' }}> 
              <Grid sx={{ width: 148, ml: '4px', display: { xs: 'none', sm: 'block' } }}><Typography sx={{ fontSize: 16, fontWeight: 600, display: { xs: 'none', sm: 'block' } }} id="info1">Type</Typography></Grid>
              <Grid sx={{ width: { xs: 92, sm: 324 }, ml: '4px' }}><Typography sx={{ fontSize: { xs: 10, sm: 16 }, fontWeight: 600 }} id="info2">Country/Currency</Typography></Grid>
              <Grid sx={{ width: { xs: 62, sm: 148 }, ml: '4px' }}><Typography sx={{ fontSize: { xs: 10, sm: 16 }, fontWeight: 600 }} id="info2">Amount</Typography></Grid>
              <Grid sx={{ width: '114px', ml: '4px', display: { xs: 'none', sm: 'block' } }}><Typography sx={{ fontSize: 16, fontWeight: 600, display: { xs: 'none', sm: 'block' } }} id="info2">Rate</Typography></Grid>
              <Grid sx={{ width: { xs: 42, sm: '114px' }, ml: '4px' }}><Typography sx={{ fontSize: { xs: 10, sm: 16 }, fontWeight: 600 }} id="info2">USD</Typography></Grid>
            </Grid>  

            {currencies.map((currency, index) =>
              <CurrencyItem activeStep={activeStep} currency={currency} index={currency.id} locator='Review' updateCurrency={updateCurrency} type='CUR' summary={currencysummary} />
            )}

            <Typography sx={{ pr: '10px', fontSize: '0.9375rem', textAlign:'end', color: '#000000', fontWeight: 'bold', height: '20px' }}> 
              Total: <NumberFormat value={(computeTotal(currencies, coins, others))} isNumericString={true} displayType={'text'} 
                        decimalScale={0} maximumfractiondigits={0} minimumfractiondigits= {0} thousandSeparator={true} prefix={'$'} /> USD
            </Typography> 

          <Grid container sx={{ display: { xs: 'none', sm: 'block' }, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-end' }}> 
            <Grid sx={{ width: '368px', ml: '24px' }}><Typography sx={{ fontSize: 16 }} id="info1">*NI: Negotiable Instruments</Typography></Grid>
            <Grid sx={{ width: '368px', ml: '24px' }}><Typography sx={{ fontSize: 16 }} id="info2">*II: Incomplete Instruments</Typography></Grid>
          </Grid>                          

          </Paper>
          
          <Paper sx={{ m: 1, p: 1, textAlign: 'left', color: 'text.primary', backgroundColor: '#ffffff', borderRadius: '12px' }}>
          <Grid container sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <Typography sx={{ fontWeight: '550', fontSize: '0.9375rem' }}  align='left' gutterBottom>Signature
            <span data-tip="Sign digitally on the signature area">
              <IconButton sx={{ ml:'2px', width:30 }} aria-label="Sign digitally on the signature area">
                  <InfoIcon sx={{ fontSize: '1.125rem', verticalAlign: 'text-top', mr:'12px' }} />
                  </IconButton></span>
                <ReactTooltip/>
            </Typography>
            <Box sx={{
              '& canvas': {
                border: '1px solid #000000',
                cursor: 'pointer',
                width: { xs: 296, sm: 504, md: 664, lg: 688 },
                height: { xs: 86, sm: 112, md: 138, lg: 138 },
              }
            }}>
              <SignatureCanvas ref={sigCanvas}
                  penColor='black' backgroundColor='#ffffff' onBegin={enableClearButton} onEnd={captureSignature}
                  canvasProps={{'aria-label':"canvas optional"}}></SignatureCanvas>
            </Box>

            {showClear &&
            <Button variant="text" color="secondary"
              onClick={clearSign}
              sx={{ fontSize: '0.75rem', fontWeight: "600", p: '4px', m: '4px', textTransform:'capitalize' }}
            >
              Clear
            </Button>
            }
          </Grid>
          <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>
            <MDTextField name='signName' label='Name' value={review.signName} handleChange={handleChange} handleError={handleError} required={true} inputProps={{maxLength: 50,}} />
            <MDTextField name='signTitle' label='Title' value={review.signTitle}  handleChange={handleChange} required={false} inputProps={{maxLength: 50,}} />              
            <MDTextField name='signDate' label='Date of Signature (UTC)' value={review.signDate}  disabled={true} required={true} />              
          </Grid>

          <Grid container sx={{ flexDirection: 'row', alignItems: 'center', mt: 2, pl: 2, backgroundColor: '#c9dbf7' }}>
            <FormControlLabel 
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontFamily: 'Roboto', fontWeight: '440', fontSize: '0.78125rem'
                    }
                  }}
                    control={
                    <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    checked={review.declaration}
                    onChange={handleDeclarationChecked('declaration')}
                    value={review.declaration}
                  />
                  }
                  label="Under penalties of perjury, I declare that I have examined this report, and to the best of my knowledge and belief is true, correct and complete."
            />                  
          </Grid>

          <Grid container sx={{ flexDirection: 'row', alignItems: 'center', mt: 2, pl: 2, backgroundColor: '#c9dbf7' }}>
            <FormControlLabel
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontFamily: 'Roboto', fontWeight: '440', fontSize: '0.78125rem'
                    }
                  }}
                    control={
                    <Checkbox
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    checked={review.acknowledgement}
                    onChange={handleAcknowledgementChecked('acknowledgement')}
                    value={review.acknowledgement}
                  />
                  }
                  label="I acknowledge that I am the transporter of the shipment, or the person that sent or received the monetary instruments through mail or courier."
            />                  
          </Grid>
              
              <NavigationButtons review={review} allReqDone={requiredFields.signName && declaration && acknowledgement 
                  && personalsummary && exportimportsummary && thirdPartySummary && mailshipSummary && currencysummary} 
                    formCompleted={props.formCompleted} />
        </Paper>

        <Popup open={open} 
          modal closeOnDocumentClick={false} >
          {close => (
          <Grid sx={{ fontSize: '1rem', opacity: '1', backgroundColor: 'transparent' }}>
          
          <Grid sx={{ textTransform: 'uppercase', fontSize: '18px', fontWeight: '500', textAlign: 'center', mt: '10px', mb: '12px', lineHeight: '1.1' }}>{alertType === 'R'? 'Required Information' : 'USD Equivalent Totals'}</Grid>
            <hr/>
              <Grid sx={{ mb: 3, fontSize: '16px', p: '15px', position: 'relative', fontFamily: 'Roboto,Calibri,Tahoma,Arial,sans-serif' }}>
                {alertType === 'R'? 'Please complete all the required fields before saving.' : 
                'Total of all USD Equivalent is either less than $10,000 or more than $2,147,483,647. Please check the Amount entered.'}
              </Grid>
            
            <Grid container sx={{ height: 68, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
              <Button variant="outlined" color="secondary" onClick={() => {closepopup()}} sx={popupCloseButtonSx}>Close</Button>               
            </Grid>
          </Grid>
          )}
      </Popup>

      </div>
  );
}

export default ReviewSign;